import moment from 'moment';

import {
  VISUAL_PROFILE_MODE_TOGGLE
} from '../../actions/visual';

const initialState = {
  profileMode: 'low',
};

const visual = (state = initialState, action) => {
  switch(action.type) {
    case VISUAL_PROFILE_MODE_TOGGLE:
      return { ...state, profileMode: state.profileMode === 'low' ? 'high' : 'low'};
    default:
      return state;
  }
}

export default visual;



// WEBPACK FOOTER //
// ./src/reducers/ui/visual.js